module.exports = __webpack_public_path__ + "media/images/posts/why_choose_winter_wedding4-8777d2c550e9254a2ca8ccb0ad84dda6.jpg";